import { I18n } from "@assets/strings";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { GroupType } from "@domain/group/group";
import { useMyOrganizations } from "@domain/organization/hooks";
import { Organization } from "@domain/organization/organization";
import { DetailedPerson } from "@domain/user/user";
import { gap } from "@ui/styles/utils";
import { PersonSelector } from "@ui/components/inputs/personSelector";
import { RadioButton } from "@ui/components/inputs/radio";

interface AssociateOrganizationSelectorProps extends React.HTMLAttributes<HTMLDivElement> {
	groupType: GroupType;
	onOrganizationChange: (org?: Organization) => void;
	currentOrganization?: Organization;
	organizationId?: string;
}
export const AssociateOrganizationSelector: React.FC<AssociateOrganizationSelectorProps> = ({
	groupType,
	currentOrganization,
	onOrganizationChange,
	organizationId,
	...htmlProps
}) => {
	const { result: organizations } = useMyOrganizations();
	const institutions = organizations.filter((org) => org.type === "INSTITUTE");

	const filteredOrganizations = organizationId
		? (institutions.filter((org) => org.id === organizationId) as DetailedPerson[])
		: institutions;

	const currentAssociateOrg = useMemo(
		() => currentOrganization ?? filteredOrganizations[0],
		[currentOrganization, filteredOrganizations, organizationId]
	);

	const [selectorVisible, setSelectorVisible] = useState(organizationId ? true : !!currentOrganization);

	useEffect(() => {
		if (selectorVisible && !currentOrganization) {
			onOrganizationChange(currentAssociateOrg as Organization);
		}
	}, [selectorVisible]);

	return (
		<Container {...htmlProps}>
			{filteredOrganizations.length > 0 && (
				<>
					<RadioButton
						checkbox
						disabled={organizationId ? true : false}
						id={"associate-" + groupType}
						name={"associate-" + groupType}
						label={I18n.t(`group.${groupType}.edit.associate_to_organization`)}
						checked={selectorVisible}
						onChange={() => {
							// if (selectorVisible) {
							// console.log("currentOrganization", currentOrganization);
							// // }
							setSelectorVisible((prev) => !prev);
						}}
					/>

					{selectorVisible && institutions.length > 0 ? (
						<PersonSelector
							current={currentAssociateOrg}
							items={filteredOrganizations}
							onItemChange={(org) => {
								onOrganizationChange(org as Organization);
							}}
							onlyOrganizations
						/>
					) : null}
				</>
			)}
		</Container>
	);
};

const Container = styled.div`
	${gap(20)};
`;
